<template>
  <v-autocomplete
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="promotionTypes"
    item-value="id"
    item-text="name"
    clearable
    multiple
    return-object
    :search-input.sync="search"
    :loading="loading"
  >
  </v-autocomplete>
</template>

<script>
import ApiService from "@/gapp-components/services/api.service";

export default {
  name: "PromotionTypesField",
  props: {
    value: Array,
    excludePromotionTypeNames: {
      type: Array,
      default: () => []
    },
    status: { type: String, required: false },
    disableAutoSelect: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    promotionTypes: [],
    search: null,
    loading: false
  }),
  watch: {
    search(value) {
      this.fetchPromotionTypes(value);
    }
  },
  methods: {
    onInput(obj) {
      if (!this.excludePromotionTypeNames) {
        this.$emit("input", obj);
        return;
      }
      let filteredPromotionTypes = obj.filter(pt => !this.excludePromotionTypeNames.includes(pt.name));
      this.$emit("input", filteredPromotionTypes);
    }
  },
  fetchPromotionTypes(search) {
    this.loading = true;

    const filters = {
      isEffective: this.status,
      keyword: search
    };

    ApiService.post("/api/promotionTypes/search?size=50", filters)
      .then(({ data }) => {
        this.promotionTypes = data.content;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  mounted() {
    let filters = {};
    filters.isEffective = this.status;

    ApiService.post("/api/promotionTypes/search?size=100", filters).then(({ data }) => {
      this.promotionTypes = data.content;
      if (this.excludePromotionTypeNames && this.excludePromotionTypeNames.length > 0) {
        let filteredPromotionTypes = data.content.filter(pt => !this.excludePromotionTypeNames.includes(pt.name));
        if (!this.disableAutoSelect) {
          this.$emit("input", filteredPromotionTypes);
        }
      }
      this.$emit("loaded");
    });
  }
};
</script>
